module.exports = __webpack_public_path__ + "static/media/tick.fde7a3d6.svg";